import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "./pages/home";
import FeedbackWeb from "./pages/feedbackWeb";
import FeedbackH5 from "./pages/feedbackH5";
import NotFound from "./pages/404";
import RegisterRule from "./pages/crmapp/registerRule";
import PrivacyPolicy from "./pages/crmapp/privacyPolicy";
import Sfa from "./pages/sfa";

function App() {
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<FeedbackWeb />}></Route>
          <Route path="/feedback/web" element={<FeedbackWeb />} />
          <Route path="/feedback/mobile" element={<FeedbackH5 />} />
          {/* crm app用户协议、隐私协议 */}
          <Route path="/register_rule" element={<RegisterRule />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/sfa" element={<Sfa />} />
          {/* 其他路由 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
